// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqQuoteDetailsSalesRepProductListStyles } from "@stanion/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsSalesRepProductList";
import { css } from "styled-components";

rfqQuoteDetailsSalesRepProductListStyles.quoteAllGridItem = {
    width: 6,
    css: css`
        justify-content: flex-end;
    `,
};

rfqQuoteDetailsSalesRepProductListStyles.productBrandAndDescriptionGridItem = {
    css: css`
        flex-direction: column;
    `,
    width: 12,
};

rfqQuoteDetailsSalesRepProductListStyles.linesheader = {
    priceUnit: {
        css: css`
            max-width: 250px;
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.footerWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-end;
        margin-top: 20px;
    `,
};

rfqQuoteDetailsSalesRepProductListStyles.totalLabelText = {
    size: 20,
    weight: "bold",
    css: css`
        margin-right: 10px;
    `,
};

rfqQuoteDetailsSalesRepProductListStyles.totalValueText = {
    size: 20,
};
